import { noscroll } from "./noscroll";

let header = document.querySelector(".header")
let headerBtn = document.querySelector(".header__burger")
let headerMenuUlLi = document.querySelectorAll(".header__menu nav ul:first-of-type li")

headerBtn.addEventListener("click", () => {
    header.classList.toggle("is-on");
    noscroll(header.classList.contains("is-on"))
})

headerMenuUlLi.forEach((li) => {
    li.addEventListener("click", () => {
        header.classList.remove("is-on");
        noscroll(header.classList.contains("is-on"))
    })
})